package uz.ferro.shop.pages.admin.export

import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import mui.material.Button
import mui.material.ButtonVariant
import mui.material.CircularProgress
import mui.system.Box
import mui.system.sx
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag
import react.FC
import react.Props
import react.useState
import uz.ferro.shop.manager.ProductManager
import uz.ferro.shop.util.formatForFileSuffix
import uz.ferro.shop.util.localizedOrDefault
import web.cssom.px
import web.dom.document
import kotlin.js.Date

val AdminExport = FC<Props> {

    var isLoading by useState(false)

    fun csvRow(data: List<String?>): String {
        return data.joinToString(separator = ",") { item ->
            var out = item.orEmpty().replace("\"", "\"\"")
            if (out.contains(Regex("[\",\n]"))) {
                out = "\"$out\""
            }
            out
        }
    }

    fun productsCsvExport() {
        MainScope().launch {
            isLoading = true
            try {
                var csv = csvRow(
                    listOf(
                        "Ferro ID",
                        "Name_uz",
                        "Name_cyr",
                        "Name_ru",
                        "Name_en",
                        "SAP Code",
                        "Is_active",
                        "Brand",
                        "Category",
                        "Type",
                        "Unit",
                        "Total Amount",
                        "Availability",
                        "Discount",
                        "Country",
                    )
                )
                val products = ProductManager.getAllProducts()
                products.forEach { p ->
                    var data = mutableListOf<String?>()

                    data.add(p.id?.toString().orEmpty())
                    data.add(p.name?.textUzLat)
                    data.add(p.name?.textUzCyr)
                    data.add(p.name?.textRu)
                    data.add(p.name?.textEn)
                    data.add(p.externalId)
                    data.add(if (p.isDisabled == true) "Inactive" else "Active")
                    data.add((p.brand ?: p.parentProduct?.brand)?.name)
                    data.add((p.parentProduct?.category ?: p.category)?.name?.textUzLat)
                    data.add(if (p.isParent == true) "Parent" else "")
                    data.add(p.unit?.name?.localizedOrDefault())
                    data.add(p.totalAmount?.toString())
                    data.add(if (p.amountNotEnough == true) "Available" else "Not available")
                    data.add(p.discountPercent?.toString())
                    data.add(p.country)

                    csv += "\n"
                    csv += csvRow(data)
                }


                var blob = Blob(blobParts = arrayOf(csv), options = BlobPropertyBag("text/csv;charset=utf-8;"))
                val a = document.createElement("a")
                var link = a
                if (link.getAttribute("download") !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    link.setAttribute("href", URL.createObjectURL(blob))
                    link.setAttribute("download", "maxsulotlar_${Date().formatForFileSuffix()}.csv");
                    document.body.appendChild(link);
                    link.click()
                    document.body.removeChild(link);
                }
            } catch (e: Exception) {
                console.log(e)
            }
            isLoading = false
        }
    }

    Box {
        sx {
            padding = 16.px
        }

        Button {
            variant = ButtonVariant.contained
            disabled = isLoading
            onClick = {
                productsCsvExport()
            }
            +"Maxsulotlar"
        }

        if (isLoading) {
            Box {
                CircularProgress()
            }
        }
    }
}